import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material'
import React from 'react'

const Cornea = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Cornea</InputLabel>
      <Select
        value={moduleValues?.[`Cornea (${side})`] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [`Cornea (${side})`]: e.target.value,
          }))
        }
        label="Cornea"
      >
        {['Cloudy', 'Foreign Body', 'Ulceration', 'Clear'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default Cornea
